import React, { FC } from 'react';
import { View, Button, Image } from '@tarojs/components';
import { ButtonProps } from '@tarojs/components/types/Button';

interface IResultProps {
  className?: string;
  imageUrl?: string;
  title?: string;
  message?: string;
  buttonText?: string;
  buttonType?: keyof ButtonProps.type;
  onButtonClick?: () => void;
}

const Result: FC<IResultProps> = ({ className = '', imageUrl = '', title, message, buttonText, buttonType, onButtonClick }) => {
  return (
    <View className={`ace-result ${className}`}>
      <View className="ace-result-content">
        <Image lazyLoad src={imageUrl} className="ace-result-image" mode="widthFix" />
        {title && <View className="ace-result-title">{title}</View>}
        {message && <View className="ace-result-message">{message}</View>}
        {buttonText && (
          <Button size="mini" className="ace-result-button" onClick={onButtonClick} type={buttonType}>
            {buttonText}
          </Button>
        )}
      </View>
    </View>
  );
};

export default Result;
